import { render } from "./ProgrammList.vue?vue&type=template&id=c6cafc1a&scoped=true"
import script from "./ProgrammList.vue?vue&type=script&lang=js"
export * from "./ProgrammList.vue?vue&type=script&lang=js"

import "./ProgrammList.vue?vue&type=style&index=0&id=c6cafc1a&lang=css&scoped=true"

import exportComponent from "/Users/mad/Business/156kr/Clients/ archive/kultursommer/kultursommer_web25/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6cafc1a"]])

export default __exports__